import React from 'react';
import PropTypes from 'prop-types';
import withHeadlineProps from './headlineProps';
import './headline.scss';

/**
 * H2 text component
 */

export function H3(props) {
	return (
		<h3 className={props.className}>
			{props.children}
		</h3>
	);
}

H3.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node
};

export default withHeadlineProps(H3);
